import { inject, injectable } from "inversify";
import { TYPES } from "../di/types";
import { ResourceLoader } from "../loader/resourceLoader/ResourceLoader";
import { AnalyticsEvent } from "./AnalyticEvent";
import { AnalyticsSender } from "./AnalyticsSender";
import ReactGA from "react-ga4";

declare global {
  interface Window {
    vintomGADataLayer: any[];
    vintomGtag: (...args: any) => void;
  }
}
let projectCode: string;

export interface GoogleAnalyticsSender extends AnalyticsSender {
  initialize(gaServiceTrackers: string[], campaign: string): void;
}

@injectable()
export class GoogleAnalyticsSenderImpl implements GoogleAnalyticsSender {
  constructor(@inject(TYPES.loader.resourceLoader.ResourceLoader) private resourceLoader: ResourceLoader) {}

  initialize(gaServiceTrackers: string[], campaign: string): void {
    projectCode = campaign;

    ReactGA.initialize(
      gaServiceTrackers.map((gaServiceTracker) => ({
        trackingId: gaServiceTracker,
        debug_mode: true,
        gtagOptions: {
          campaign_name: projectCode,
        },
      })),
    );
  }

  sendEvent(event: AnalyticsEvent): void {
    const eventAction = event.type === "SCENARIO_ELEMENT_PROGRESS" ? `PROGRESS_${event.progress}` : event.type;

    const eventLabel = this.serializeEventToAction(event);

    if (eventAction !== undefined && event.type !== "SCENARIO_ELEMENT_PLAYING" && event.type !== "SCENARIO_ELEMENT_START") {
      ReactGA.event({
        category: projectCode,
        action: projectCode + ": " + eventAction,
        label: eventLabel,
      });
    }
  }

  private serializeEventToAction(event: AnalyticsEvent): string {
    const base = `scenario element id: ${event.scenarioElementId}`;

    switch (event.type) {
      case "PLAYER_INIT":
        return base;
      case "PLAYER_START":
        return base;
      case "PLAYER_ERROR":
        return `${base}, message: ${event.errorMessage}`;
      case "SCENARIO_ELEMENT_START":
        return base;
      case "SCENARIO_ELEMENT_PROGRESS":
        return base;
      case "CTA_SHOW":
        return `${base}, cta id: ${event.ctaId}`;
      case "CTA_ACTION":
        return `${base}, cta id: ${event.ctaId}, action id: ${event.actionId}`;
      case "NOT_SUPPORTED_BROWSER":
        return base;
      default:
        // all other events are ignored by GoogleAnalyticsSender
        return undefined;
    }
  }
}
